import styled from 'styled-components';

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default FlexRow;
